import React from 'react';

import { ContentBlock } from 'components/modules/AutoruLayout/ContentBlock/ContentBlock';
import { CombinedInputs } from 'components/modules/Insurance/components/CombinedInputs/CombinedInputs';
import { DatePicker } from 'components/modules/Insurance/components/DatePicker/DatePicker';
import { FormWrapper } from 'components/modules/Insurance/components/FormWrapper/FormWrapper';
import {
  MAX_DATE,
  MIN_DATE,
  NUMBER_MAX_99_MASK,
  OUTPUT_CUSTOMER_DATE_FORMAT,
} from 'components/modules/Insurance/Insurance.constants';
import { InputMask } from 'utils/inputMask';

import { NAMES } from './DriverLicense.constants';
import { useDriverLicensePresenter } from './DriverLicense.presenter';
import * as S from './DriverLicense.styles';

export const DriverLicense = ({ isOwnerForm }) => {
  const presenter = useDriverLicensePresenter({ isOwnerForm });

  return (
    <ContentBlock title="Водительское удостоверение">
      <FormWrapper>
        <S.TextInputMasked
          disabled={presenter.disabled}
          error={presenter.errors[NAMES.SERIES_AND_NUMBER]}
          label="Серия, номер"
          mask={InputMask.DRIVE_LICENSE_SERIES_NUMBER}
          name={NAMES.SERIES_AND_NUMBER}
          unmask={false}
          value={presenter.values[NAMES.SERIES_AND_NUMBER]}
          onChange={presenter.onChange}
        />
        <DatePicker
          disabled={presenter.disabled}
          error={presenter.errors[NAMES.DATE_ISSUE]}
          label="Дата выдачи"
          maxDate={MAX_DATE}
          minDate={MIN_DATE}
          name={NAMES.DATE_ISSUE}
          outputFormat={OUTPUT_CUSTOMER_DATE_FORMAT}
          value={presenter.values[NAMES.DATE_ISSUE]}
          onChange={presenter.onChange}
        />
        <S.TextInputMasked
          disabled={presenter.disabled}
          error={presenter.errors[NAMES.EXPERIENCE]}
          label="Стаж вождения"
          mask={NUMBER_MAX_99_MASK}
          name={NAMES.EXPERIENCE}
          value={presenter.values[NAMES.EXPERIENCE]}
          onChange={presenter.onChange}
        />
      </FormWrapper>
      <S.IsFirstLicenseSwitcher
        disabled={presenter.disabled}
        name={NAMES.CHANGED}
        value={presenter.values[NAMES.CHANGED]}
        onChange={presenter.onChange}
      />
      {presenter.values[NAMES.CHANGED] ? (
        <FormWrapper>
          <CombinedInputs>
            <S.TextInputMasked
              disabled={presenter.disabled}
              error={presenter.errors[NAMES.PREVIOUS_SERIES]}
              label="Серия предыдущего ВУ"
              mask={InputMask.DRIVE_LICENSE_SERIES}
              name={NAMES.PREVIOUS_SERIES}
              value={presenter.values[NAMES.PREVIOUS_SERIES]}
              onChange={presenter.onChange}
            />
            <S.TextInputMasked
              disabled={presenter.disabled}
              error={presenter.errors[NAMES.PREVIOUS_NUMBER]}
              label="Номер предыдущего ВУ"
              mask={InputMask.DRIVE_LICENSE_NUMBER}
              name={NAMES.PREVIOUS_NUMBER}
              value={presenter.values[NAMES.PREVIOUS_NUMBER]}
              onChange={presenter.onChange}
            />
          </CombinedInputs>
          <DatePicker
            disabled={presenter.disabled}
            error={presenter.errors[NAMES.PREVIOUS_DATE_ISSUE]}
            label="Дата выдачи предыдущего ВУ"
            maxDate={presenter.maxPreviousDateIssue}
            minDate={MIN_DATE}
            name={NAMES.PREVIOUS_DATE_ISSUE}
            outputFormat={OUTPUT_CUSTOMER_DATE_FORMAT}
            value={presenter.values[NAMES.PREVIOUS_DATE_ISSUE]}
            onChange={presenter.onChange}
          />
        </FormWrapper>
      ) : null}
    </ContentBlock>
  );
};
